import { ConfigProvider, Menu } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { AuthContext } from "../providers/AuthProvider";
import { useContext } from "react";
import { useGetConstantsQuery } from "../redux/services/constants";
import { navIcons } from "../assets/navigation-icons";
import { TbTargetArrow } from "react-icons/tb";
import { CustomIcon } from "../utils";
import getTenantId from "../components/Tenent";
import { FiUpload } from 'react-icons/fi';

const tenantId = getTenantId();
console.log("tenantIdishre", tenantId);
const isKarbonWiseAdminItems = [
  {
    label: "Activity",
    key: "emission-activities",
    icon: <CustomIcon svg={navIcons.Activity} />,
    children: [
      {
        label: "GHG emissions",
        key: "/emission-activities",
      },
      // {
      //   label: "ESG emissions",
      //   key: "/emission-activities/esg-module",
      // },
      // {
      //   label: "ESG metrics",
      //   key: "/emission-activities/esg",
      // },
    ],
  },

  // {
  //   label: "Upload Stream",
  //   key: "/upload-stream/proofs",
  //   icon: <FiUpload />,
  // },
  {
    label: "Analytics",
    key: "/analytics",
    icon: <CustomIcon svg={navIcons.Analytics} />,
    children: [
      {
        label: "Analytics",
        key: "/analytics",
      },
      (tenantId === "innovo" || tenantId === "elkay" ||
        tenantId === "stage" ||
        tenantId === "trial") && {
        label: "Custom Dashboard",
        key: "/dashboard", //Group GHG
        // children: [
        //   {
        //     label: "Group GHG",
        //     key: "/dashboard",
        //   },
        //   {
        //     label: "Scope 1",
        //     key: "/dashboard/scope-1",
        //   },
        //   {
        //     label: "Scope 2",
        //     key: "/dashboard/scope-2",
        //   },
        //    {
        //     label: "Scope 3 Cat1",
        //     key: "/dashboard/scope-3 cat1",
        //   },
        //    {
        //     label: "Scope 3 Cat2",
        //     key: "/dashboard/scope-3 cat2",
        //   },
        //    {
        //     label: "Scope 3 Cat5",
        //     key: "/dashboard/scope3-cat5",
        //   },
        //   {
        //     label: "Scope 3 - Cat6,7,8",
        //     key: "/dashboard/scope3-other",
        //   },
        //   // {
        //   //   label: "",
        //   //   key: "/dashboard/",
        //   // },
        //   // add more children
        // ]
      },
    ],
  },
  {
    label: "Target Setting",
    key: "target-emmision",
    icon: <TbTargetArrow />,
    children: [
      {
        label: "Create Targets",
        key: "/createtarget",
      },
      {
        label: "Set Targets",
        key: "/settarget",
      },
    ],
  },
  {
    label: "Reports",
    key: "/reports",
    icon: <CustomIcon svg={navIcons.Report} />,
    // children: [
    //   {
    //     label: "TCFD",
    //     key: "/reports/tcfd",
    //   },
    //   {
    //     label: "PPN0621",
    //     key: "/reports/ppn",
    //   },
    //   // {
    //   //   label: "BRSR",
    //   //   key: "/reports/brsr",
    //   // },
    // ],
  },
  // {
  //   label: "Task List",
  //   key: "/task-list",
  //   icon: <CustomIcon svg={navIcons.Task} />,
  // },
  {
    label: "Information",
    key: "admin",
    icon: <CustomIcon svg={navIcons.Config} />,
    children: [
      {
        label: "Users",
        key: "/information/users",
      },
      {
        label: "Update Password",
        key: "/information/update-password"
      },
      {
        label: "Roles & Permissions",
        key: "/information/admin"
      },
      {
        label: "Activity logs",
        key: "/information/activity-logs",
      },
      {
        label: "Organization Hierarchy",
        key: "/information/organization-hierarchy",
      },
      // {
      //   label: "Emission Targets",
      //   key: "/information/emission-targets",
      // },
      {
        label: "Base Metrics",
        key: "/information/base-metrics",
      },
      // {
      //   label: "Master",
      //   key: "Master",
      //   children: [
      //     {
      //       label: "Suppliers",
      //       key: "/admin/supplier",
      //     },
      //     // {
      //     //   label: "Buyers",
      //     //   key: "/admin/buyers",
      //     // },
      //     // {
      //     //   label: "Products",
      //     //   key: "/admin/products",
      //     // },
      //     {
      //       label: "Spend Group",
      //       key: "/information/spend-group",
      //     },
      //   ],
      // },
      {
        label: "Configuration inputs",
        key: "Configuration inputs",
        children: [
          {
            label: "Constants",
            key: "/information/constants",
          },
          // tenantId !== "johncotton" && {
          //   label: "Reports Templates",
          //   key: "/information/prompt-reports",
          // },
          // {
          //   label: "Account",
          //   key: "/information/account",
          // },
          {
            label: "Categories",
            key: "/admin/categories",
          },
        ],
      },
      {
        label: "Uncertainty Analysis",
        key: "/information/uncertainty-analysis",
      },
    ],
  },
];
const isCompanyStaffItems = [
  {
    label: "Activity",
    key: "emission-activities",
    icon: <CustomIcon svg={navIcons.Activity} />,
    children: [
      {
        label: "GHG emissions",
        key: "/emission-activities",
      },
      // {
      //   label: "ESG metrics",
      //   key: "/emission-activities/esg",
      // },
    ],
  },
  {
    label: "Upload Stream",
    key: "/upload-stream/proofs",
    icon: <FiUpload />,
  },
  {
    label: "Analytics",
    key: "/analytics",
    icon: <CustomIcon svg={navIcons.Analytics} />,
    children: [
      {
        label: "Analytics",
        key: "/analytics",
      },
      tenantId === "innovo" && {
        label: "Custom Dashboard",
        key: "/dashboard", //Group GHG
        // children: [
        //   {
        //     label: "Group GHG",
        //     key: "/dashboard",
        //   },
        //   {
        //     label: "Scope 1",
        //     key: "/dashboard/scope-1",
        //   },
        //   {
        //     label: "Scope 2",
        //     key: "/dashboard/scope-2",
        //   },
        //   {
        //     label: "Scope 3 Cat1",
        //     key: "/dashboard/scope-3 cat1",
        //   },
        //   {
        //     label: "Scope 3 Cat2",
        //     key: "/dashboard/scope-3 cat2",
        //   },
        //   {
        //     label: "Scope 3 Cat5",
        //     key: "/dashboard/scope3-cat5",
        //   },
        //   {
        //     label: "Scope 3 - Cat6,7,8",
        //     key: "/dashboard/scope3-other",
        //   },
        //   // {
        //   //   label: "",
        //   //   key: "/dashboard/",
        //   // },
        //   // add more children
        // ],
      },
    ],
  },
  {
    label: "Target Setting",
    key: "target-emmision",
    icon: <TbTargetArrow />,
    children: [
      {
        label: "Create Targets",
        key: "/createtarget",
      },
      {
        label: "Set Targets",
        key: "/settarget",
      },
    ],
  },
  {
    label: "Reports",
    key: "/reports",
    icon: <CustomIcon svg={navIcons.Report} />,
  },
  {
    label: "Task List",
    key: "/task-list",
    icon: <CustomIcon svg={navIcons.Task} />,
  },
  {
    label: "Information",
    icon: <CustomIcon svg={navIcons.Config} />,
    key: "/information/uncertainty-analysis",
    children: [
      {
        label: "Uncertainty Analysis",
        key: "/information/uncertainty-analysis",
      },
    ],
  },
];
const isCompanyAdminItems = [
  {
    label: "Activity",
    key: "emission-activities",
    icon: <CustomIcon svg={navIcons.Activity} />,
    children: [
      {
        label: "GHG emissions",
        key: "/emission-activities",
      },
      // {
      //   label: "ESG metrics",
      //   key: "/emission-activities/esg",
      // },
    ],
  },
  {
    label: "Upload Stream",
    key: "/upload-stream/proofs",
    icon: <FiUpload />,
  },
  {
    label: "Analytics",
    key: "/analytics",
    icon: <CustomIcon svg={navIcons.Analytics} />,
    children: [
      {
        label: "Analytics",
        key: "/analytics",
      },
      tenantId === "innovo" && {
        label: "Custom Dashboard",
        key: "/dashboard", //Group GHG
        // children: [
        //   {
        //     label: "Group GHG",
        //     key: "/dashboard",
        //   },
        //   {
        //     label: "Scope 1",
        //     key: "/dashboard/scope-1",
        //   },
        //   {
        //     label: "Scope 2",
        //     key: "/dashboard/scope-2",
        //   },
        //   {
        //     label: "Scope 3 Cat1",
        //     key: "/dashboard/scope-3 cat1",
        //   },
        //   {
        //     label: "Scope 3 Cat2",
        //     key: "/dashboard/scope-3 cat2",
        //   },
        //   {
        //     label: "Scope 3 Cat5",
        //     key: "/dashboard/scope3-cat5",
        //   },
        //   {
        //     label: "Scope 3 - Cat6,7,8",
        //     key: "/dashboard/scope3-other",
        //   },
        //   // {
        //   //   label: "",
        //   //   key: "/dashboard/",
        //   // },
        //   // add more children
        // ],
      },
    ],
  },
  {
    label: "Target Setting",
    key: "target-emmision",
    icon: <TbTargetArrow />,
    children: [
      {
        label: "Create Targets",
        key: "/createtarget",
      },
      {
        label: "Set Targets",
        key: "/settarget",
      },
    ],
  },
  {
    label: "Reports",
    key: "/reports",
    icon: <CustomIcon svg={navIcons.Report} />,
  },
  {
    label: "Task List",
    key: "/task-list",
    icon: <CustomIcon svg={navIcons.Task} />,
  },
  {
    label: "Information",
    key: "admin",
    icon: <CustomIcon svg={navIcons.Config} />,
    children: [
      {
        label: "Users",
        key: "/information/users",
      },
      {
        label: "Uncertainty Analysis",
        key: "/information/uncertainty-analysis",
      },
    ],
  },
];

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isKarbonWiseAdmin,
    isAccountOwner,
    isAccountStaff,
    isCompanyAdmin,
    isCompanyStaff,
  } = useContext(AuthContext);
  const onClick = (e) => {
    e.key !== null && navigate(e.key);
  };
  // const getMenuItemsList = () => {
  //   if (isKarbonWiseAdmin || isAccountOwner || isAccountStaff || 1) {
  //     return isKarbonWiseAdminItems;
  //   } else if (isCompanyStaff) {
  //     return isCompanyStaffItems;
  //   } else {
  //     return isCompanyAdminItems;
  //   }
  // };
  const tenantId = getTenantId();
  console.log("Tenant ID:------------------------->", tenantId);
  const { data } = useGetConstantsQuery({
    key: "APP_LOGO",
  });

  return (
    // <Row>
    //   <Space
    //     direction="vertical"
    //     style={{
    //       width: "100%",
    //       height: "100%",
    //       justifyContent: "space-between",
    //     }}
    //   >
    <ConfigProvider
      theme={{
        token: {
          // Seed Token
          iconSize: 30,
          colorPrimary: "#00b96b",
          colorIcon: "red",
        },
        components: {
          Menu: {
            colorIcon: "green",
            size: "30px",
            fontSizeIcon: "50px",
            colorInfoActive: "red",
          },
        },
      }}
    >
      <Menu
        mode="inline"
        selectedKeys={[location.pathname]}
        onClick={onClick}
        items={isKarbonWiseAdminItems}
        // selectable={false}
        style={{
          paddingBottom: "150px",
        }}
      />
    </ConfigProvider>
    //   </Space>
    // </Row>
  );
};
export default SideBar;
